import { Modal } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { showAlert } from 'actions/client';
import ConfirmationDialog from 'components/Utility/Dialogs/ConfirmationDialog';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Loader } from 'react-overlay-loader';
import { connect } from 'react-redux';
import {
  getFormValues,
  initialize,
  isValid,
  reduxForm,
  reset,
} from 'redux-form';
import {
  createUser,
  deleteACLUser,
  fetchACLUsers,
  fetchUserRole,
  UpdateACLUser,
} from '../../../../../../actions/authentication';
import UsersDetailsForm from './UserDetailsForm';

class UserDetailsModal extends React.Component {
  state = {
    formPage: 0,
    showDeleteConfirmation: false,
    showDeleteWithRefundConfirmation: false,
    showRefundConfirmation: false,
    attachedPermissions: [],
  };

  constructor(props) {
    super(props);
    this.handleAttachedPermissions = this.handleAttachedPermissions.bind(this);
  }

  handleAttachedPermissions(attachedPermissions) {
    this.setState({ attachedPermissions });
  }

  componentWillMount() {}

  componentWillUpdate(nextProps, nextState) {
    const nextBooking = nextProps.booking || undefined;

    if (!this.props.open && this.state.formPage !== 0) {
      this.setState({ formPage: 0 });
    }

    if (!this.props.open && nextProps.open) {
      this.props.dispatch(
        initialize('userDetails', convertBookingToForm(nextBooking), false)
      );
    }

    // if (!nextProps.creatingBooking && this.props.creatingBooking) {
    //   if (nextProps.bookingCreated && !this.props.bookingCreated) {
    //     this.showBookingCreated();
    //     this.props.onComplete();
    //   } else {
    //     if (nextProps.creatingBookingErr === 'timeout') {
    //       this.showCreationError(
    //         'Poor Internet Connectivity',
    //         'Your internet connection appears to be slow or offline. This booking will be uploaded in the background.'
    //       );

    //       this.props.onComplete(false);
    //     } else if (nextProps.creatingBookingErr !== null) {
    //       this.showCreationError(
    //         null,
    //         `We could not create this booking: ${nextProps.creatingBookingErr}`
    //       );
    //     } else {
    //       this.showCreationError();
    //     }
    //   }
    // }

    // if (!nextProps.editingBooking && this.props.editingBooking) {
    //   if (nextProps.bookingEdited && !this.props.bookingEdited) {
    //     this.showBookingEdited();
    //     this.props.onComplete();
    //   } else {
    //     this.showBookingEditError();
    //   }
    // }

    // if (!nextProps.deletingBooking && this.props.deletingBooking) {
    //   if (nextProps.bookingDeleted && !this.props.bookingDeleted) {
    //     this.showBookingDeleted();
    //     this.props.onComplete();
    //   } else {
    //     this.showBookingDeleteError();
    //   }
    // }

    // if (!nextProps.refundingBooking && this.props.refundingBooking) {
    //   if (nextProps.bookingRefunded && !this.props.bookingRefunded) {
    //     this.showBookingRefunded();
    //     this.props.onComplete();
    //   } else {
    //     this.showBookingRefundedError();
    //   }
    // }
  }

  // Form Navigation

  handleChange = (event, formPage) => {
    this.setState({ formPage });
  };

  closeForm = () => {
    this.props.dispatch(reset('userDetails'));
    this.props.onClose();
  };

  nextPage = () => this.setState({ formPage: this.state.formPage + 1 });

  previousPage = () => this.setState({ formPage: this.state.formPage - 1 });

  // Booking Actions

  editBooking = () => {
    if (this.props.formValid) {
      const data = this.sanitizeFormValues(this.props.formValues);
      this.props.editBooking({ booking: data });
    } else {
      this.showFormError();
    }
  };

  editACLUser = () => {
    this.setState({ loading: true });
    if (this.props.formValid) {
      const payload = {
        user_id: this.props.booking.id,
        permissions: this.state.attachedPermissions,
      };
      this.props.updateACLUser(payload).then(() => {
        this.props.fetchACLUsers(this.props.venue._id).then(() => {
          this.props.fetchUserRole();
          this.props.onClose();
          this.props.onComplete();
          this.setState({ loading: false });
        });
      });
    } else {
      this.showFormError();
    }
  };

  deleteBooking = applyRefund => {
    this.hideDeleteWithRefundConfirmation();
    this.props.deleteBooking(this.props.booking.id, applyRefund);
  };

  deleteACLUser = () => {
    if (this.props.booking.id === this.props.loggedUser.id) {
      this.props.showAlert('Cannot Delete User', 'You cannot delete yourself.');
      this.setState({ showDeleteConfirmation: false });
      return;
    }

    this.setState({ loading: true });
    this.hideDeleteConfirmation();
    this.props.deleteACLUser(this.props.booking.id).then(() => {
      this.props.fetchACLUsers(this.props.venue._id).then(() => {
        this.props.onClose();
        this.props.onComplete();
        this.setState({ loading: false });
      });
    });
  };

  createUser = () => {
    this.setState({ loading: true });
    if (this.props.formValid) {
      const data = this.sanitizeFormValues(this.props.formValues);
      const forename = data.name.split(' ')[0];
      const surname = data.name.split(' ')[1];
      const payload = {
        user: {
          forename,
          surname,
          email: data.email,
        },
        permissions: this.state.attachedPermissions,
      };
      this.props.createUser(payload).then(() => {
        this.props.fetchACLUsers(this.props.venue._id).then(() => {
          this.props.onClose();
          this.props.onComplete();
          this.setState({ loading: false });
          // this.showReservationConfirmedModal();
        });
      });
    } else {
      this.setState({ loading: false });
      this.showFormError();
    }
  };

  sanitizeFormValues = formValues => {
    const newFormValues = {};
    newFormValues['name'] = formValues['name'];
    newFormValues['email'] = formValues['email'];

    newFormValues['permissions'] = formValues['permissions'];

    return newFormValues;
  };

  // Alerts

  showFormError = isDate => {
    if (isDate) {
      this.props.showAlert(
        'Invalid Date',
        'You are missing the reservation date, make sure you choose todays date or onwards.'
      );
      return;
    }
    this.props.showAlert(
      'Invalid Details',
      'You are missing some required fields.'
    );
  };

  showCreationError = (title, desc) => {
    this.props.showAlert(
      title || 'A Problem Occurred',
      desc || 'We could not create the booking. Try again later.'
    );
  };

  showBookingCreated = () => {
    this.props.showAlert(
      'Created Booking',
      'Successfully created booking. The customer has received an email.'
    );
  };

  showBookingEdited = () => {
    this.props.showAlert('Booking Edited', 'Successfully edited booking.');
  };

  showBookingEditError = () => {
    this.props.showAlert(
      'Could not edit booking',
      'Failed to edit booking. Please try again later.'
    );
  };

  showBookingDeleted = () => {
    this.props.showAlert('Booking Deleted', 'Successfully deleted booking.');
  };

  showBookingDeleteError = () => {
    this.props.showAlert(
      'Could not delete booking',
      'Failed to delete booking. Please try again later.'
    );
  };

  showBookingRefunded = () => {
    this.props.showAlert('Booking Refunded', 'Successfully refunded booking.');
  };

  showBookingRefundedError = () => {
    this.props.showAlert(
      'Could not refund booking',
      'Failed to refund booking. Please try again later.'
    );
  };

  showDeleteConfirmation = () =>
    this.setState({ showDeleteConfirmation: true });

  showReservationConfirmedModal = () => {
    this.setState({
      showModal: true,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  hideDeleteWithRefundConfirmation = () =>
    this.setState({ showDeleteWithRefundConfirmation: false });

  hideDeleteConfirmation = () =>
    this.setState({ showDeleteConfirmation: false });

  render() {
    const formPage = this.state.formPage;
    const editMode = this.props.booking ? true : false;
    const customerName = editMode
      ? false
      : this.sanitizeFormValues(this.props.formValues).name;

    const title = editMode ? 'Edit User' : 'Add User';

    return (
      <div>
        <Dialog
          fullWidth={true}
          disableEscapeKeyDown={true}
          fullScreen={this.props.fullScreen}
          open={this.props.open}
          onClose={this.props.onClose}
          //aria-labelledby="venue-switcher"
        >
          <DialogTitle
            style={{ paddingBottom: 0 }}
            id="responsive-dialog-title"
          >
            <span className="booking__details__title">{title}</span>

            {/* {isReservatiodPaid && (
              <span className="booking__details__paid"> (Confirmed)</span>
            )} */}
          </DialogTitle>

          <DialogContent>
            <UsersDetailsForm
              active={formPage === 0}
              formValues={this.props.formValues}
              menuList={this.props.menuList}
              handleAttachedPermissions={this.handleAttachedPermissions}
              showAlert={this.props.showAlert}
            />
          </DialogContent>

          <DialogActions
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div>
              {formPage === 0 && (
                <Button
                  onClick={editMode ? this.editACLUser : this.createUser}
                  color="primary"
                >
                  {editMode ? 'Save' : 'Create'}
                </Button>
              )}
              {editMode && (
                <Button
                  onClick={this.showDeleteConfirmation}
                  className="delete__btn"
                  color="primary"
                  variant="contained"
                  size="small"
                >
                  Remove
                </Button>
              )}
            </div>
            {formPage === 0 && (
              <Button onClick={this.closeForm} color="secondary">
                Close
              </Button>
            )}
          </DialogActions>

          <Loader loading={this.state.loading} />
        </Dialog>

        <ConfirmationDialog
          open={this.state.showDeleteConfirmation}
          confirmationTitle="Delete User"
          confirmationDescription="You are about to delete this user. Are you sure this is the action you wish to perform?"
          onClose={this.hideDeleteConfirmation}
          onConfirm={this.deleteACLUser}
        />

        <ConfirmationDialog
          open={this.state.showRefundConfirmation}
          confirmationTitle="Refund Booking"
          confirmationDescription="You are about to refund this booking. Are you sure this is the action you wish to perform?"
          onClose={this.hideRefundConfirmation}
          onConfirm={this.refundBooking}
        />

        <ConfirmationDialog
          open={this.state.showDeleteWithRefundConfirmation}
          confirmationTitle="Apply Refund"
          confirmationDescription="Do you also wish to apply a refund to this booking before deleting it?"
          onClose={() => this.deleteBooking(false)}
          onConfirm={() => this.deleteBooking(true)}
        />
        {!editMode && (
          <Modal
            open={this.state.showModal}
            onClose={this.handleCloseModal}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div className="order-container">
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  onClick={this.handleCloseModal}
                  style={{
                    border: 'none',
                    background: 'none',
                    fontSize: '20px',
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <h2>Reservation Sent</h2>
              <hr />
              <p>A reservation link has been sent to {customerName}'s phone.</p>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

const convertBookingToForm = (booking, currency, lastUsedDepositDetails) => {
  if (!booking) {
    booking = { menu: '' };
  }

  const name = `${booking.forename || ''}${
    booking.forename && booking.surname ? ' ' : ''
  }${booking.surname || ''}`;

  return {
    id: booking.id,
    name,
    email: booking.email,
    permissions: booking.permissions,
  };
};

const mapStateToProps = (state, ownProps) => {
  const booking = ownProps.booking || undefined;
  // const bookingReducer = state.booking;

  const initialValues = convertBookingToForm(booking);
  return {
    loggedUser: state.authentication.user,
    users:
      (state.authentication.ACLUsers && state.authentication.ACLUsers.users) ||
      [],
    formValues: getFormValues('userDetails')(state) || {},
    formValid: isValid('userDetails')(state),
    initialValues: initialValues,
    venue: state.venue,
  };
};

const mapDispatchToProps = dispatch => ({
  createUser: user => dispatch(createUser(user)),
  updateACLUser: payload => dispatch(UpdateACLUser(payload)),
  fetchACLUsers: venue_id => dispatch(fetchACLUsers(venue_id)),
  deleteACLUser: user_id => dispatch(deleteACLUser(user_id)),
  showAlert: (title, desc) => dispatch(showAlert(title, desc)),
  fetchUserRole: () => dispatch(fetchUserRole()),
});

UserDetailsModal.propTypes = {
  booking: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  askForTime: PropTypes.bool.isRequired,
};

UserDetailsModal = reduxForm({
  form: 'userDetails',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(UserDetailsModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(UserDetailsModal));



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/UserDetailsModal/index.jsx